<template>
  <div class="empty-section" :class="{smaller}">
    <img src="@/assets/img/empty.png">
    <div class="empty__title" v-if="!hideTitle">{{$t('oops')}}!</div>
    <div class="empty__text" v-html="text"></div>
    <button class="btn btn-primary" v-if="button && button.action" @click="button.action()">
      <svgicon src="icon/circle-add.svg" :height="24" :width="24"></svgicon>
      {{button.text}}
    </button>
  </div>
</template>

<script>
  export default {
    name: "Empty",

    props: {
      text: String,
      hideTitle: Boolean,
      smaller: Boolean,
      button: Object
    }
  }
</script>

<style lang="scss" scoped>
  .smaller {
    img {
      max-width: 300px;
    }
  }
  .btn-primary {
    font-size: 20px;
    color: white;
    fill: white;
    padding: 16px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    .svgicon {
      margin-right: 16px;
    }
  }
  .empty-section {
    align-self: center;
    justify-self: center;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px;
    display: flex;
    flex-direction: column;
  }
  .empty__title {
    font-size: 40px;
    font-weight: bold;
    color: #1a1a1a;
    padding-top: 40px;
  }
  .empty__text {
    font-size: 14px;
    color: #808080;
    max-width: 450px;
    margin-bottom: 40px;
    margin-top: 20px;
    text-align: center;
  }
  img {
    max-width: 400px;
    width: 100%;
    height: auto;
    margin-bottom: 20px;
  }
</style>